import React from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'

import styles from './styles.scss'

export function ResourcesBanner({
  heading,
  subHeading,
  leftImage,
  rightImage,
}: IProps): React.ReactElement {
  return (
    <div className="resources-banner__wrapper">
      <div className="resources-banner">
        <img className="banner-left-image" src={leftImage} alt="" />
        <div className="banner-middle-item">
          <h1 className="banner-middle-item__heading">
            <Text brand="default" size="heading-1-default">
              {heading}
            </Text>
          </h1>
          <div className="banner-middle-item__subheading">
            <Text brand="default" size="body">
              {subHeading}
            </Text>
          </div>
        </div>
        <img className="banner-right-image" src={rightImage} alt="" />
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
